// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var CardList    = require("./CardList");
var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.js");

function encodeBoard(param) {
  return Json_encode.object_(/* :: */[
              /* tuple */[
                "name",
                param[/* name */0]
              ],
              /* :: */[
                /* tuple */[
                  "lists",
                  $$Array.of_list(List.map(CardList.encode, param[/* lists */1]))
                ],
                /* [] */0
              ]
            ]);
}

function decodeBoard(json) {
  return /* record */[
          /* name */Json_decode.field("name", Json_decode.string, json),
          /* lists */Json_decode.field("lists", (function (param) {
                  return Json_decode.list(CardList.decode, param);
                }), json)
        ];
}

exports.encodeBoard = encodeBoard;
exports.decodeBoard = decodeBoard;
/* CardList Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/State.re
// module id = 49
// module chunks = 0